import { useMutation } from '@tanstack/react-query';
import useGetMarketingData from './useGetMarketingData';
import { deleteCampaign } from '../../services/marketing';
import { invalidateOffboardingCampaigns } from '../../services/offboardings';

interface Options {
  onSuccess?: () => void;
  onError?: () => void;
  onMutate?: () => void;
  onSettled?: () => void;
}

function useDeleteCampaign({
  onSuccess,
  onError,
  onMutate,
  onSettled,
}: Options = {}) {
  const { data, isFetching, refetch } = useGetMarketingData();

  return useMutation({
    mutationFn: async (campaignId: string) => {
      if (!data?.id || isFetching) return null;

      const result = await deleteCampaign(data?.id, campaignId);
      return result;
    },
    onSuccess: async () => {
      await refetch();
      await invalidateOffboardingCampaigns();
      if (onSuccess) onSuccess();
    },
    onError,
    onMutate,
    onSettled,
  });
}

export default useDeleteCampaign;
